import React from 'react';
export function QualifiedBanner() {
  return <div className="w-full bg-[#3DA5D9] py-4 px-4 flex justify-center items-center" data-id="element-64">
      <p className="text-white italic text-lg md:text-2xl text-center" data-id="element-65">
        <span className="bg-white/30 px-2 py-0.5 rounded font-semibold not-italic mr-1" data-id="element-66">
          48,459
        </span>
        Americans Qualified For The 2025 Debt Relief Program
      </p>
    </div>;
}